import dataController from '@/lib/dataController';
import model from '@/models/project';
import AppPage from '@/ui/AppPage/AppPage';
import { Box } from '@mui/material';
import * as React from 'react';
import { useParams } from 'react-router';
import { Permissions } from "@/lib/permissions";
import menuRoutes from '@/routes/menu';
import ProjectForm from './ProjectForm';
import DialogProvider from '@/ui/DialogContext/DialogProvider';


function ProjectPage() {
  const { project_id } = useParams();
  const dc = new dataController(model);

  const recordId = parseInt(project_id ? project_id : '', 10);

  return (
    <DialogProvider>
      <AppPage menu={menuRoutes} needPermission={[Permissions.Administration]}>
        <Box m={2}>
          <ProjectForm dc={dc} recordId={recordId} mode="update" form="update" />
        </Box>
      </AppPage>
    </DialogProvider>
  );
}

export default ProjectPage;